.accordion_item
    margin-bottom: 30px